import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';

// Request body type
export interface SetGuidedOnboardingActionRequestBody {
  action: {
    actionId: string;
    isCompleted: boolean;
  };
}

// Response type
export interface SetGuidedOnboardingActionResponse {
  action: {
    actionId: string;
    isCompleted: boolean;
  };
}

export const SetGuidedOnboardingActionRequestConfig: Omit<RestApiRequestConfig<SetGuidedOnboardingActionRequestBody, {}>, 'requestBody' | 'headers' | 'queryParams'> = {
  restApiVersion: '3.27',
  httpMethod: 'PUT',
  endpoint: 'onboarding/actions',
};

export function setGuidedOnboardingAction(
  body: SetGuidedOnboardingActionRequestBody
) {
  const config: RestApiRequestConfig<SetGuidedOnboardingActionRequestBody, {}> = {
    ...SetGuidedOnboardingActionRequestConfig,
    requestBody: body,
  };
  return makeRestApiRequest<SetGuidedOnboardingActionRequestBody, SetGuidedOnboardingActionResponse>(config);
}
